import { render, staticRenderFns } from "./mytabPane.vue?vue&type=template&id=7c52bf3a&scoped=true"
import script from "./mytabPane.vue?vue&type=script&lang=js"
export * from "./mytabPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c52bf3a",
  null
  
)

export default component.exports